import PlainDate from '@Domain/PlainDate';

export type PeriodPreset = {
	readonly key: 'thisMonth' | 'lastMonth' | 'lastThreeMonths';
	readonly label: string;
	readonly from: PlainDate;
	readonly to: PlainDate;
};

/** The three period shortcuts as of `today`; the last one spans three months ending today, bounds included. */
const resolvePeriodPresets = (today: PlainDate): readonly PeriodPreset[] => {
	const lastDayOfPreviousMonth = new Date(today.year, today.month - 1, 0);
	const threeMonthsAgo = new Date(today.year, today.month - 4, today.day + 1);

	return [
		{ key: 'thisMonth', label: 'Ce mois-ci', from: new PlainDate(today.year, today.month, 1), to: today },
		{
			key: 'lastMonth',
			label: 'Mois dernier',
			from: new PlainDate(
				lastDayOfPreviousMonth.getFullYear(),
				lastDayOfPreviousMonth.getMonth() + 1,
				1,
			),
			to: PlainDate.fromCalendar(lastDayOfPreviousMonth),
		},
		{
			key: 'lastThreeMonths',
			label: '3 derniers mois',
			from: PlainDate.fromCalendar(threeMonthsAgo),
			to: today,
		},
	];
};

export default resolvePeriodPresets;
